import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../styles'
import Icon from '../../components/icon/Icon'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'

const useStyle = makeStyles((theme) => ({
		...styles(theme),
		containerDiv: {
			display: 'flex',
			alignItems: 'center',
			maxHeight: 41
		},
		containerDivLargeScreen: {
			breakInside: 'avoid-column',
			marginBottom: 30
		},
		containerDivSmallScreen: {
			marginBottom: 17
		},
		textDivLargeScreen: {
			display: 'flex',
			flexDirection: 'column',
			marginLeft: 16
		},
		textDivSmallScreen: {
			marginLeft: '3%',
			display: 'flex',
			flexWrap: 'wrap'
		},
		textTitle: {
			color: theme.palette.blue.main
		},
		textTitleSmall:{
			color: theme.palette.blue.main,
			marginRight: 8
		},
		textNumber: {
			color: theme.palette.accessibility.main
		},
		icon: {
			fill: theme.palette.blue.main
		}
	}
))

interface AcceptingProps {
	iconName: string,
	title: string,
	number: string
}

type IconNumberComponentProps = AcceptingProps

const IconNumberComponent: React.FC<IconNumberComponentProps> = (
	{
		iconName, title, number
	}
) => {
	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 760px)'
		}
	)

	const textTitle = classNames(
		isLargeScreen? classes.textTitle : classes.textTitleSmall,
		classes.semiBold,
		classes.text4
	)

	const textNumber = classNames(
		classes.textNumber,
		classes.text3,
		classes.medium
	)

	const textDivClass = classNames(
		isLargeScreen ? [classes.textDivLargeScreen] : [classes.textDivSmallScreen]
	)

	const containerDivClass = classNames(
		isLargeScreen ? [classes.containerDivLargeScreen] : [classes.containerDivSmallScreen],
		classes.containerDiv
	)
	return (
		<div className={containerDivClass}>
			<Icon size={isLargeScreen? 32 : 22} icon={iconName} className={classes.icon} />
			<div className={textDivClass}>
				<span className={textTitle}>
					{title}
				</span>
				<div>
					<span className={textNumber}>
						{number}
					</span>
				</div>

			</div>

		</div>
	)
}
export default IconNumberComponent
